export default function PlayerHome() {
  return (
    <div className="prose">
      <h2>General information</h2>
      <p>
        This section covers an overview of Q-Play player software, typical deployment scenarios, and core concepts
        like player registration, pairing, and content synchronization.
      </p>
      <ul>
        <li>Player lifecycle and updates — Todo</li>
        <li>Networking and firewall considerations — Todo</li>
        <li>Logging and diagnostics — Todo</li>
      </ul>
    </div>
  )
}
